module.exports = __webpack_public_path__ + "fonts/Roboto-ThinItalic.35a9c89a.ttf";